export default __webpack_public_path__ + "static/media/home-travel-agency-tour-type-img02.b32360dd.jpg";